import ImageHoverPopup from "../../../../components/ImageHoverPopup";
import titleCaseString from "../../../../utils/titleCaseUtils";
import ImageGallery from "react-image-gallery";


import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";


import { useState, useRef } from "react";


/* CSS */
import '../../../../styles/imagezoomhovereffect.css';

const TabParticipants = ({selectedItem}) => {
 const [index, setIndex] = useState(-1);

      const DateFormatter = ({ date }) => {
            const formatDate = (date) => {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };
        
            // Format the date without the time
            return new Date(date).toLocaleDateString('en-US', options);
            };
        
            return <div>{formatDate(date)}</div>;
        };

     

          const images = [

                // VALID IDS
                { 
                    src: selectedItem.attachment_id_file,
                    // description: "1st Party Valid ID",
                    title: "1ST PARTY VALID ID",
                },

                // PRINCIPALS IMAGE
                { 
                    src: selectedItem.principal_image,
                    // description: "1st Party Captured Image",
                    title: "1ST PARTY CAPTURED IMAGE",

                },

                // DYNAMIC ADDING OF ARRAY IF EXISTS
                ...(selectedItem.second_party_attachment_id_file
                ? [
                    {
                    src: selectedItem.second_party_attachment_id_file,
                    // description: "2nd Party Valid ID",
                    title: "2ND PARTY VALID ID",

                    },
                ]
                : []),


                 ...(selectedItem.second_party_image
                ? [
                    {
                    src: selectedItem.second_party_image,
                    // description: "2nd Party Captured Image",
                    title: "2ND PARTY CAPTURED IMAGE",
                    },
                ]
                : []),
               
            ];


        

    return (
    
              <div className="col-12 mb-md-0 mb-4">
                <div className="card shadow-none">
               


                  <div className="card-body">
                    <div className="row">
                        
               
                          <div className="col-md-6">
                            

                                <Lightbox
                                    open={index >= 0}
                                    close={() => setIndex(-1)}
                                    slides={images} 
                                    index={index}
                                    onIndexChange={setIndex}
                                    plugins={[Captions]}
                                    captions={{ descriptionTextAlign: "center" }}
                                />

                           


                              <div className="table-responsive  w-100">
                                <table className="table table-bordered" >
                                  <tr className="border">
                                    <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">1st Party Valid ID</th>
                                </tr>
                                  <tbody>

                                    <tr>
                                        <td colSpan={2} className="p-0">
                                            <div className="d-flex flex-column align-items-center">
                                                {selectedItem.attachment_id_file && 
                                                    <>
                                                        {/* {images.map((image, i) => ( */}
                                                            <img
                                                                // key={i}
                                                                src={images[0].src}
                                                                alt={`1st Party Valid ID`}
                                                                style={{cursor: "pointer", maxHeight:250,minHeight:250,objectFit:"contain"}}
                                                                onClick={() => setIndex(0)}
                                                                className=" img-fluid hover-zoom "
                                                            />
                                                        {/* ))} */}
                                                    </>
                                                }
                                            </div>
                                        </td>
                                    </tr>




                                    <tr>
                                      <td style={{ overflow: "hidden" }}>
                                        <i className="bx bx-collection" /><span className="fw-medium mx-2">Type:</span>
                                      </td>
                                      <td className="fw-bold"> {selectedItem.attachment_id_type} </td>
                                    </tr>

                                    <tr>
                                      <td style={{ overflow: "hidden" }}>
                                        <i className="bx bx-id-card" /><span className="fw-medium mx-2">ID No:</span>
                                      </td>
                                      <td className="fw-bold"> {selectedItem.attachment_id_number} </td>
                                    </tr>

                                    <tr>
                                      <td style={{ overflow: "hidden" }}>
                                        <i className="bx bx-calendar" /><span className="fw-medium mx-2">Date issued:</span>
                                      </td>
                                      <td className="fw-bold"> {<DateFormatter date={selectedItem.attachment_id_date_issued?.toString() ?? ''} />} </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                             
                          </div>

                 
                            {selectedItem.second_party_attachment_id_file &&
                                <div className="col-md-6">
                                    <div className="table-responsive  w-100">
                                        <table className="table table-bordered" >
                                            <tr className="border">
                                                <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">2nd Party Valid ID</th>
                                            </tr>
                                            <tbody>

                                                <tr>
                                                    <td colSpan={2} className="p-0">
                                                        <div className="d-flex flex-column align-items-center">
                                                            {selectedItem.second_party_attachment_id_file &&
                                                                <>
                                                                    <img
                                                                        // key={i}
                                                                        src={images[2].src}
                                                                        alt={`2nd Party Valid ID`}
                                                                        style={{ cursor: "pointer", maxHeight: 250,minHeight:250,objectFit:"contain" }}
                                                                        onClick={() => setIndex(2)}
                                                                        className=" img-fluid hover-zoom "
                                                                    />
                                                                </>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ overflow: "hidden" }}>
                                                        <i className="bx bx-collection" /><span className="fw-medium mx-2">Type:</span>
                                                    </td>
                                                    <td className="fw-bold"> {selectedItem.second_party_attachment_id_type} </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ overflow: "hidden" }}>
                                                        <i className="bx bx-id-card" /><span className="fw-medium mx-2">ID No:</span>
                                                    </td>
                                                    <td className="fw-bold"> {selectedItem.second_party_attachment_id_number} </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ overflow: "hidden" }}>
                                                        <i className="bx bx-calendar" /><span className="fw-medium mx-2">Date issued:</span>
                                                    </td>
                                                    <td className="fw-bold"> {selectedItem.second_party_attachment_id_date_issued ? <DateFormatter date={selectedItem.second_party_attachment_id_date_issued?.toString() ?? null} /> : ""} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                    </div>
                  </div>
                  


                  {/* PAGE INFO */}
                  <div className="card-body">
                    <div className="row">
                   

{/* 1st Party */}
                      <div className="col-md-12">

                        <table className="table table-bordered"  >
                          <tr className="border">
                            <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">1st Party Information</th>
                          </tr>

                          <tbody>
                            <tr>
                              <td colSpan={2}>
                                <div className="d-flex flex-column align-items-center">
                                  {selectedItem.principal_image ? 
                                    <img
                                        src={images[1].src}
                                        alt={`1st Party`}
                                        style={{ cursor: "pointer", maxHeight: 250, objectFit: "cover" }}
                                        onClick={() => setIndex(1)}
                                        className="rounded-pill shadow hover-zoom "
                                        height={200} width={200}
                                    />

                                  :
                                    <strong className="text-danger">
                                        No image was captured of this participant during the oath-taking.
                                    </strong>
                                  
                                  }
                                </div>

                              </td> 

                            </tr>



                            <tr>
                              <td width={"50%"}>
                                <i className="bx bx-edit" /><span className="fw-medium mx-2">Full Name:</span>
                              </td>
                              <td className="fw-bold">
                                {titleCaseString(
                                  (selectedItem.first_name +
                                    (selectedItem.middle_name ? ' ' + selectedItem.middle_name : '') +
                                    ' ' +
                                    selectedItem.last_name +
                                    (selectedItem.suffix ? ' ' + selectedItem.suffix : '')
                                  )
                                )}
                              </td>

                            </tr>

                            <tr>
                              <td>
                                <i className="bx bx-calendar-alt" /><span className="fw-medium mx-2">Birthday:</span>
                              </td>
                              <td className="fw-bold">{<DateFormatter date={selectedItem.birth_date?.toString() ?? Date.now()} />}</td>
                            </tr>
                            <tr>
                              <td>
                                <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span>
                              </td>
                              <td className="fw-bold">{titleCaseString(selectedItem.gender.toUpperCase())}</td>

                            </tr>
                            <tr>
                              <td>
                                <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                              </td>
                              <td className="fw-bold">{selectedItem.contact_number}</td>

                            </tr>
                            <tr>
                              <td>
                                <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                              </td>
                              <td className="fw-bold">{selectedItem.email}</td>

                            </tr>

                            <tr>
                              <td>
                                <i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span>
                              </td>

                              <td>
                               {selectedItem.signature_file && 
                                <ImageHoverPopup
                                  imageSrc={selectedItem.signature_file}
                                  altText="Signature"
                                  height={30}
                                  label="SIGNATURE"
                                />
                              }
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>

{/* 2nd Party */}
                      {selectedItem.second_party_first_name && selectedItem.second_party_last_name &&
                        <div className="col-md-12">
                          <table className="table table-bordered"  >
                            <tr className="border">
                              <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">2nd Party Information</th>
                            </tr>

                            <tbody>
                              <tr>
                                <td colSpan={2}>
                                    <div className="d-flex flex-column align-items-center">
                                        {selectedItem.second_party_image ?
                                            <img
                                                src={images[3].src}
                                                alt={`2nd Party`}
                                                style={{ cursor: "pointer", maxHeight: 250, objectFit: "cover" }}
                                                onClick={() => setIndex(3)}
                                                className="rounded-pill shadow hover-zoom "
                                                height={200} width={200}
                                            />

                                            :
                                            <strong className="text-danger">
                                                No image was captured of this participant during the oath-taking.
                                            </strong>

                                        }
                                    </div>
                                </td>

                              </tr>



                              <tr>
                                <td width={"50%"}>
                                  <i className="bx bx-edit" /><span className="fw-medium mx-2">Full Name:</span>
                                </td>
                                <td className="fw-bold">
                                  {selectedItem.second_party_first_name && selectedItem.second_party_last_name && titleCaseString(
                                    (selectedItem.second_party_first_name +
                                      (selectedItem.second_party_middle_name ? ' ' + selectedItem.second_party_middle_name : '') +
                                      ' ' +
                                      selectedItem.second_party_last_name +
                                      (selectedItem.second_party_suffix ? ' ' + selectedItem.second_party_suffix : '')
                                    )
                                  )}
                                </td>

                              </tr>

                              <tr>
                                <td>
                                  <i className="bx bx-calendar-alt" /><span className="fw-medium mx-2">Birthday:</span>
                                </td>
                                <td className="fw-bold">{selectedItem.second_party_birth_date && <DateFormatter date={selectedItem.second_party_birth_date?.toString() ?? Date.now()} />}</td>
                              </tr>
                              <tr>
                                <td>
                                  <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span>
                                </td>
                                <td className="fw-bold">{titleCaseString(selectedItem.second_party_gender?.toUpperCase())}</td>

                              </tr>
                              <tr>
                                <td>
                                  <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                                </td>
                                <td className="fw-bold">{selectedItem.second_party_contact_number}</td>

                              </tr>
                              <tr>
                                <td>
                                  <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                                </td>
                                <td className="fw-bold">{selectedItem.second_party_email}</td>

                              </tr>

                              <tr>
                                <td>
                                  <i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span>
                                </td>

                                <td>
                                  {selectedItem.second_party_signature_file &&
                                    <ImageHoverPopup
                                      imageSrc={selectedItem.second_party_signature_file}
                                      altText="Signature"
                                      height={30}
                                      label="SIGNATURE"
                                    />
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                      }



                          {/* <h4 className="bg-label-primary py-2 mx-0 rounded">Witness(es)</h4> */}

    

                     




                          {/* {selectedItem.witnessFirstFullname &&
                            <div className="d-flex pt-4 bg-label-secondary rounded-pill">
                              <div className="col mb-0  d-flex flex-column align-items-center">
                                <h6 className="pb-2 fw-bold">WITNESS 1</h6>
                                {selectedItem.witnessFirstPhoto && <img src={URL.createObjectURL(selectedItem.witnessFirstPhoto)} alt={`Valid ID`} className="rounded" height={200} width={200} />}
                                <h6 className="pb-0 mb-0 fw-bold mt-2">{selectedItem.witnessFirstFullname.toUpperCase()}</h6>

                                {selectedItem.witnessFirstPhotoSignature && <img src={selectedItem.witnessFirstPhotoSignature} alt={`Witness 1 Signature`} className="rounded mb-0" height={150} width={200} />}
                                <h6 className="pb-0 mb-0 fw-bold mt-0">Signature</h6>

                              </div>

                              {selectedItem.witnessSecondFullname &&
                                (
                                  <div className="col mb-0  d-flex flex-column align-items-center">
                                    <h6 className="pb-2 fw-bold">WITNESS 2</h6>
                                    {selectedItem.witnessSecondPhoto && <img src={URL.createObjectURL(selectedItem.witnessSecondPhoto)} alt={`Valid ID`} className="rounded" height={200} width={200} />}
                                    <h6 className="pb-0 mb-0 fw-bold mt-2">{selectedItem.witnessSecondFullname.toUpperCase()}</h6>
                                    

                                    {selectedItem.witnessSecondPhotoSignature && <img src={selectedItem.witnessSecondPhotoSignature} alt={`Witness 2 Signature`} className="rounded" height={150} width={200} />}
                                    <h6 className="pb-2 fw-bold mt-0">Signature</h6>

                                  </div>
                                )
                              }
                            </div>
                          }
                           */}


                     
                    </div>
                  </div>


                  <div className="card-body">
                    <div className="row">
                           {selectedItem.witnesses && selectedItem.witnesses.length > 0 &&
                            selectedItem.witnesses.map((witness, index) => (
                                <div className="col" key={index}>
                                    <div className="table-responsive  w-100">
                                        <table className="table table-bordered" >
                                            <tr className="border">
                                                <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Witness {index + 1}</th>
                                            </tr>
                                            <tbody>

                                                <tr>
                                                    <td colSpan={2} className="p-0">
                                                        <div className="d-flex flex-column ">
                                                            {witness.participant_profile_photo &&
                                                                <>
                                                                    <img
                                                                        src={witness.participant_profile_photo}
                                                                        alt={`Witness`}
                                                                        style={{ maxHeight: 250, objectFit: "cover" }}
                                                                    />
                                                                </>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ overflow: "hidden" }}>
                                                        <i className="bx bx-collection" /><span className="fw-medium mx-2">Fullname:</span>
                                                    </td>
                                                    <td className="fw-bold">
                                                        {witness.participant_fullname ? witness.participant_fullname?.toUpperCase() :
                                                            <strong className="text-danger">
                                                                This witness does not appear during the oath-taking.
                                                            </strong>
                                                        } </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ overflow: "hidden" }}>
                                                        <i className="bx bx-collection" /><span className="fw-medium mx-2">Contact:</span>
                                                    </td>
                                                    <td className="fw-bold"> {witness.contact_info} </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span>
                                                    </td>

                                                    <td>
                                                        {witness.participant_signature_path &&
                                                            <ImageHoverPopup
                                                                imageSrc={witness.participant_signature_path}
                                                                altText="Signature"
                                                                height={30}
                                                                label="SIGNATURE"
                                                            />
                                                        }
                                                    </td>
                                                </tr>


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                  </div>


                 

 
                 
              
                </div>
              </div> 
     );
}
 
export default TabParticipants;